module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "tochd"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Contents")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Intro"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_FM1"
    }
  }, [_vm._v("Family tree: House of Lancaster")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/08_FM2"
    }
  }, [_vm._v("Family tree: House of York")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/09_FM3"
    }
  }, [_vm._v("Family tree: Katherine of Aragon’s descent from Edward III")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2a"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/10_chap01"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 1")]), _vm._v(" Out of Avalon")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/11_chap02"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 2")]), _vm._v(" The Once and Future King")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_chap03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 3")]), _vm._v(" A Christian Prince")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_chap04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 4")]), _vm._v(" Diseased Minds")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_chap05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 5")]), _vm._v(" The King’s Most Dear Son")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_chap06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 6")]), _vm._v(" The Prince of Wales")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/16_chap07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 7")]), _vm._v(" The Maintenance of His State")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/17_chap08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 8")]), _vm._v(" The Marcher Lord")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/18_chap09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 9")]), _vm._v(" So Great the Abundance")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/19_chap10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 10")]), _vm._v(" A Rose Between Thorns")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/20_chap11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 11")]), _vm._v(" The Spanish Princess")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/21_chap12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 12")]), _vm._v(" Secure in His Kingdom")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/22_chap13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 13")]), _vm._v(" The Condition of Wedlock")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/23_chap14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 14")]), _vm._v(" Portrait of a Prince")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/24_chap15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 15")]), _vm._v(" A Night in Spain")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/25_chap16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 16")]), _vm._v(" Righteous Order and Wisdom")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/26_chap17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 17")]), _vm._v(" Le Morte d’Arthur")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/27_chap18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "tpad"
  }, [_vm._v("Chapter 18")]), _vm._v(" King Arthur")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1a"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/28_epi",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue: The Shadow of a Prince")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/29_notes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/30_bib",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Selected Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c3907da2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_Toc.vue
// module id = 69
// module chunks = 0